<div class="back-img">
  <ion-row *ngIf="this.isMobile" class="ion-justify-content-end">
    <ion-button (click)="close()" strong="true" fill="clear" color="dark">
      <ion-icon size="large" name="close-outline"></ion-icon>
    </ion-button>
  </ion-row>
</div>
